import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSignupPageData, signup } from '../Actions/NewsletterSignup.action';
import DynamicComponent from '../../../Components/DynamicComponent';
import * as yup from 'yup';

import { translate } from '../../../Services/translation';

const NewsletterSignupContainer = ({ placement }) => {
    const dispatch = useDispatch();

    const [signupEmail, setSignupEmail] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const [policyChecked, setPolicyChecked] = useState(false);
    const [showPolicyCheckbox, setShowPolicyCheckbox] = useState(true);
    const { showSignupMessage, newsletterSignupData, status } = useSelector(
        (state) => state.newsletterSignup
    );
    // Validation
    let validationSchema = yup.object().shape({
        email: yup.string().email(),
    });

    useEffect(() => {
        dispatch(getSignupPageData());
        setIsMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            if (!signupEmail) {
                setIsEmailValid(false);
            } else {
                validateEmail();
            }
        }
    }, [signupEmail]);

    const sendEmail = () => {
        validateEmail(true);
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };

    const validateEmail = (isFinalCheck = false) => {
        validationSchema
            .isValid({
                email: signupEmail,
                placement,
            })
            .then((valid) => {
                setIsEmailValid(valid);
                if (isFinalCheck) {
                    dispatch(signup(signupEmail, placement, newsletterSignupData.showVoucherCode || ''));
                }
            });
    };

    if (!newsletterSignupData) {
        return null;
    }

    if (showSignupMessage) {
        return (
            <div className="pn-newsletter-signup__container">
                <section
                    dangerouslySetInnerHTML={{
                        __html:
                            newsletterSignupData.signedUpText ||
                            translate('addons.newslettersignup.signuptext'),
                    }}
                />
                {newsletterSignupData.showVoucherCode &&
                    newsletterSignupData.voucherCode && (
                        <section className="row collapse pn-newsletter-signup__copy-code-wrapper">
                            <div className="small-7 columns">
                                <div className=" pn-newsletter-signup__copy-code">
                                    {newsletterSignupData.voucherCode}
                                </div>
                            </div>
                            <div
                                className="small-5 columns"
                                onClick={() =>
                                    copyToClipboard('{ newsletterSignupData.voucherCode }')
                                }
                            >
                                <button className="button pn-newsletter-signup__copy-code-button">
                                    {newsletterSignupData.buttonCopyCodeText ||
                                        translate('addons.newslettersignup.button.copycode')}
                                </button>
                            </div>
                        </section>
                    )}
            </div>
        );
    }

    return (
        <div className="pn-newsletter-signup__container">
            <h3 className="small"
                dangerouslySetInnerHTML={{
                    __html: translate('addons.newslettersignup.mainheader'),
                }}
            ></h3>
            <input
                type="email"
                id="email"
                placeholder="Din mailadress"
                name="signupEmail"
                required
                onChange={(e) => setSignupEmail(e.target.value)}
            />
            <button
                className="button button__theme arrow-right-on-hover"
                disabled={!isEmailValid || (!policyChecked && showPolicyCheckbox)}
                onClick={() => sendEmail()}
            >
                {newsletterSignupData.buttonSendText ||
                    translate('addons.newslettersignup.buttonsendtext')}
            </button>
            {showPolicyCheckbox &&
                <section>
                    <label>
                        <input
                            type="checkbox"
                            id="pn_signup"
                            name="consent-checkbox"
                            className="consent-checkbox"
                            onChange={(e) => setPolicyChecked(!policyChecked)}
                            checked={policyChecked}
                        />

                        <section
                            className="checkbox-label"
                            dangerouslySetInnerHTML={{
                                __html:
                                    newsletterSignupData.descriptionText ||
                                    translate('addons.newslettersignup.descriptiontext'),
                            }}
                        ></section>
                    </label>
                </section>
            }
        </div>
    );
};
export default NewsletterSignupContainer;
